import React, { useEffect, useRef, useState } from "react";
import Header from "../common/Header";
import $ from "jquery";
import triangle from "../../images/triangle.svg";
import { Link, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import Select from "react-select";
import moment from "moment";
import Toastify from "../common/Toastify";
import { GETREQUEST, POSTREQUEST } from "../helpers/ServiceRequest";
import { addTrailingZeros, formatPrice } from "../helpers/common";
import { generateProductCreditPdf } from "../Pdfs/ProductCredit";

const ProduceCredit = () => {
    const navigate = useNavigate();
    const creditDetailObj = {
        Qty: '',
        UnitID: '',
        ProductID: '',
        AgentID: '',
        Comment: '',
        ProdCreditAmt: '',
        ProdCreditGSTAmt: '',
    }
    const [errors, setErrors] = useState({});
    const [creditDetails, setCreditDetails] = useState([creditDetailObj]);
    const [customerDetailsObj, setCustomerDetailsObj] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [agents, setAgents] = useState([]);
    const [units, setUnits] = useState([]);
    const [products, setProducts] = useState([]);
    const [returnDate, setReturnDate] = useState(moment().format('YYYY-MM-DD'));
    const [reference, setReference] = useState('');
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');
    const [focusIndex, setFocusIndex] = useState(0);
    const [focusEndIndex, setFocusEndIndex] = useState(null);
    const [customeCodeErr, setCustomeCodeErr] = useState(false);
    const [referenceErr, setreferenceErr] = useState(false);
    const { user } = useAuth();
    const creditInputRefs = useRef([]);
    const creditEndInputRefs = useRef([]);

    useEffect(() => {
        var headerHeight = $("header").outerHeight();
        var mainHeight = $(window).height() - headerHeight;
        $("main").height(mainHeight);
        $("main").css("margin-top", headerHeight + "px");

        var tableRow = ".table-form tbody > tr";

        $(tableRow).on("focusin", function () {
            $(this).addClass("focus-tr");
        });

        $(tableRow).on("focusout", function () {
            $(this).removeClass("focus-tr");
        });
    });

    useEffect(() => {
        const fetchData = async () => {
            let commanURL = process.env.REACT_APP_API_URL + "/get-comman-all-for-product";
            let userURL = process.env.REACT_APP_API_URL + "/search-customer";
            let PURL = process.env.REACT_APP_API_URL + "/search-product";

            let commonResponse = await GETREQUEST(commanURL, user.jwtToken);
            let userResponse = await GETREQUEST(userURL, user.jwtToken, false);
            let productsResponse = await GETREQUEST(PURL, user.jwtToken);

            if (commonResponse?.data) {
                let agentList = [];
                commonResponse.data.agent.forEach((item) => {
                    agentList = [...agentList, { label: item.AgentCode, value: item.AgentID }];
                });
                setAgents(agentList);

                let unitList = [];
                commonResponse.data.units.forEach((item) => {
                    unitList = [...unitList, { label: item.UnitName, value: item.UnitID }];
                });
                setUnits(unitList);
            }

            if (userResponse?.data) {
                let ccList = [];
                userResponse.data.forEach((item) => {
                    ccList = [...ccList, { label: item.CustomerCode, value: item.value, ...item }];
                });
                setCustomers(ccList);
            }

            if (productsResponse?.data) {
                let productList = [];
                productsResponse.data.forEach((item) => {
                    if (item.product.Current)
                        productList = [...productList, { label: item.product?.ProductName, value: item.value, productCode: item.label, GST: item.product?.GST }];
                });
                setProducts(productList);
            }
        }
        fetchData();
    }, []);

    useEffect(() => {
        if (focusIndex && creditInputRefs.current[focusIndex]) {
            creditInputRefs.current[focusIndex].focus();
        }
    }, [focusIndex]);

    useEffect(() => {
        if (focusEndIndex != null && creditEndInputRefs.current[focusEndIndex]) {
            creditEndInputRefs.current[focusEndIndex].focus();
        }
    }, [focusEndIndex]);

    const getReference = async() => {
        let refURL = process.env.REACT_APP_API_URL + "/get-prod-creditnote-ref";
        let response = await GETREQUEST(refURL, user.jwtToken);
        if(response?.data){
            setReference(response.data.CNReference.toString());
            setreferenceErr(false);
        }
    }

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            color: "gray",
            backgroundColor: state.isSelected ? "#01B1E3" : "#fff",
            zIndex: 9999,
        }),
    };

    const CustomOption = (props) => {
        return (
            <div
                className=""
                style={{
                    background: props.isFocused
                        ? '#01B1E3'
                        : props.isSelected
                            ? 'rgb(54, 179, 126)'
                            : "#fff", color: "gray", zIndex: 1, padding: " 8px 12px", cursor: "default", display: "block", fontSize: "inherit", width: "100%"
                }}
                {...props.innerProps}
                ref={props.innerRef}
            >
                {props.label}
            </div>
        )
    }


    const calculateTotalCredit = () => {
        let total = 0;
        creditDetails.map((credit) => {
            let value = credit.ProdCreditAmt;
            if (value)
                total += parseFloat(value);
        });
        return total ? total.toFixed(2) : 0.00
    }

    const calculateGST = (value, index) => {
        value = parseFloat(value)
        let productID = creditDetails[index].ProductID;
        let GST = products.find(prod => prod.value === productID)?.GST;
        if (GST) {
            let GSTValue = value / 11;
            setCreditDetails(prevProdDetails => {
                const updatedProdDetails = [...prevProdDetails];
                updatedProdDetails[index].ProdCreditGSTAmt = GSTValue
                return updatedProdDetails;
            });
        }
    }

    const checkError = (value, index, field) => {
        if (index < creditDetails.length - 1) {
            if (!value) {
                setErrors((prevData) => ({
                    ...prevData,
                    [field + index]: true
                }));
            } else {
                setErrors((prevData) => {
                    const updatedError = { ...prevData };
                    delete updatedError[field + index];
                    return updatedError;
                });
            }
        }
    };

    const checkRows = (index) => {
        const fields = ['Qty', 'UnitID', 'ProductID', 'AgentID', 'ProdCreditAmt'];
        let returnValue = false;
        if (creditDetails.length === 1 || Object.keys(errors).length === 0) {
            fields.map((field) => {
                let value = creditDetails[index][field]
                if (!value) {
                    setErrors((prevData) => ({
                        ...prevData,
                        [field + index]: true
                    }));
                    returnValue = true
                } else {
                    setErrors((prevData) => {
                        const updatedError = { ...prevData };
                        delete updatedError[field + index];
                        return updatedError;
                    });
                    returnValue = false
                }
            });
        }
        return returnValue;
    }

    const addNewRow = (index) => {
        const isErrors = checkRows(index);
        if (isErrors) {
            setFocusEndIndex(index);
        }
        if (creditDetails.length - 1 == index && Object.keys(errors).length === 0) {
            setCreditDetails(prevCrateDetails => {
                const updatedCrateDetails = [...prevCrateDetails, creditDetailObj];
                return updatedCrateDetails;
            });
            setFocusIndex(index + 1)
        }
    }

    const handleDelete = (index) => {
        let creditD = creditDetailObj.filter((a, i) => index !== i);
        setCreditDetails(creditD);
    };

    const handleSave = async () => {
        if (validateForm()) {
            let updatedProdDetails = [];
            creditDetails.map((creditItem) => {
                if (creditItem.Qty !== '' && creditItem.UnitID !== '' && creditItem.ProductID && creditItem.ProdCreditAmt) {
                    updatedProdDetails.push({
                        ...creditItem,
                        ProdCreditAmt: creditItem.ProdCreditAmt ? parseFloat(creditItem.ProdCreditAmt).toFixed(2) : 0,
                        ProdCreditGSTAmt: creditItem.ProdCreditGSTAmt ? parseFloat(creditItem.ProdCreditGSTAmt).toFixed(2) : 0,
                    })
                }
            })
            let payload = {
                CustomerID: customerDetailsObj?.CustomerID,
                ReturnDate: returnDate,
                ReferenceNo: reference,
                creditDetails: updatedProdDetails
            }
            let saveURL = process.env.REACT_APP_API_URL + "/create-prod-credit-note";
            setMessage('')
            setMessageType('')
            let response = await POSTREQUEST(saveURL, payload, user.jwtToken);
            if (response?.data) {
                if (response.data.success) {
                    setMessage(response.data.message);
                    setMessageType('success');
                    navigate(`/view-edit-produce-credit/${response.data.CNID}`)
                } else {
                    setMessage(response.data.message);
                    setMessageType('error');
                }
            } else {
                setMessage(response?.error?.message || 'Failed to create product credit !!');
                setMessageType('error');
            }
        }
    }

    const validateForm = () => {
        if (customerDetailsObj === null) {
            setCustomeCodeErr(true);
        }
        // if (reference == "") {
        //     setreferenceErr(true);
        // }
        if (Object.keys(errors).length !== 0 || customerDetailsObj === null) {
            return false;
        }
        else {
            return true
        }
    }

    const handlePreview = () => {
        let updatedProdDetails = [];
        creditDetails.map((creditItem) => {
            if (creditItem.Qty !== '' && creditItem.UnitID !== '' && creditItem.ProductID && creditItem.ProdCreditAmt) {
                updatedProdDetails.push({
                    ...creditItem,
                    ProdCreditAmt: creditItem.ProdCreditAmt ? parseFloat(creditItem.ProdCreditAmt).toFixed(2) : 0,
                    ProdCreditGSTAmt: creditItem.ProdCreditGSTAmt ? parseFloat(creditItem.ProdCreditGSTAmt).toFixed(2) : 0,
                })
            }
        })
        let previewData = {
            CNID: "",
            ReturnDate: returnDate,
            ReferenceNo: reference,
            tblCustomer: customerDetailsObj,
            products,
            units,
            creditDetails: updatedProdDetails
        }
        generateProductCreditPdf(previewData);
    }

    return (
        <React.Fragment>
            <Header />
            {message && <Toastify message={message} type={messageType} />}
            <main className="bg-lite-grey overflow-auto">
                <section className="px-4 pt-3 pb-4 overflow-hidden table-listing">
                    <div className="table-elements">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item fs-15">
                                    <Link
                                        to="/all-orders"
                                        className="text-decoration-none text-primary"
                                    >
                                        Credit
                                    </Link>
                                </li>
                                <li
                                    className="breadcrumb-item fs-15 active"
                                    aria-current="page"
                                >
                                    Product Credit
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="card border-bottom-0">
                        <div className="card-header bg-white d-flex align-items-lg-center justify-content-between cpx-20 cpy-14 sticky-top flex-nowrap">
                            <h1 className="title-semibold fs-24 mb-xl-0 mb-0 d-flex align-items-center text-nowrap me-5 me-xl-0">
                                Enter Product Credit
                            </h1>
                            <div className="filter-elements d-flex align-items-center">
                                <div className="custom-group flex-nowrap mb-xl-0">
                                    <label
                                        htmlFor=""
                                        className="pe-2 d-flex align-items-center fs-14 text-lite"
                                    >
                                        Code:
                                    </label>
                                    <div className="date position-relative cme-15">
                                        <Select
                                            className={`${customeCodeErr ? 'react-select-invalid' : ''} `}
                                            value={customerDetailsObj}
                                            isSearchable={true}
                                            styles={customStyles}
                                            options={customers}
                                            placeholder="Select Code"
                                            onChange={(e) => { setCustomerDetailsObj(e); setCustomeCodeErr(false) }}
                                            components={{ Option: CustomOption }}
                                        />
                                    </div>
                                </div>

                                <div className="custom-group flex-nowrap mb-lg-0">
                                    <label
                                        htmlFor=""
                                        className="pe-2 d-flex align-items-center fs-14 text-lite"
                                    >
                                        Return date:
                                    </label>
                                    <div className="position-relative cme-12" data-provide="datepicker">
                                        <input
                                            type="date"
                                            id="datepicker"
                                            className="form-control input-sm date input-datepicker"
                                            placeholder="Select Date"
                                            defaultValue={returnDate}
                                            onChange={(e) => {
                                                setReturnDate(e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="custom-group flex-nowrap mb-lg-0 pe-3">
                                    <label
                                        htmlFor=""
                                        className="pe-2 d-flex align-items-center fs-14 text-lite"
                                    >
                                        Credit No:
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control input-sm input-width-180`}
                                        disabled
                                    />
                                </div>

                                <div className="custom-group flex-nowrap mb-lg-0">
                                    <label
                                        htmlFor=""
                                        className="pe-2 d-flex align-items-center fs-14 text-lite"
                                    >
                                        Reference:
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control input-sm input-width-180 ${referenceErr ? 'is-invalid' : ''}`}
                                        value={reference}
                                        onChange={(e) => {
                                            setReference(e.target.value);
                                            setreferenceErr(false)
                                        }}
                                    />
                                </div>
                            </div>
                            <div></div>
                        </div>
                        <div className="card-header bg-white d-flex align-items-lg-center justify-content-between cpx-20 cpy-14 flex-nowrap">
                            <div className="filter-elements d-flex align-items-center justify-content-around w-100">
                                <div className="flex-nowrap mb-lg-0">
                                    <label
                                        htmlFor=""
                                        className="pe-2 d-flex align-items-center fs-14 text-lite"
                                    >
                                        Buyer Code
                                    </label>
                                    <input type="text"
                                        className="form-control input-sm"
                                        value={customerDetailsObj?.BuyerCode}
                                    />
                                </div>
                                <div className="flex-nowrap mb-lg-0">
                                    <label
                                        htmlFor=""
                                        className="pe-2 d-flex align-items-center fs-14 text-lite"
                                    >
                                        Customer Code
                                    </label>
                                    <input type="text"
                                        className="form-control input-sm"
                                        value={customerDetailsObj?.CustomerCode}
                                    />
                                </div>
                                <div className="flex-nowrap mb-lg-0">
                                    <label
                                        htmlFor=""
                                        className="pe-2 d-flex align-items-center fs-14 text-lite"
                                    >
                                        Customer Contact
                                    </label>
                                    <input type="text"
                                        className="form-control input-sm"
                                        value={customerDetailsObj?.CustomerContact}
                                    />
                                </div>
                                <div className="flex-nowrap mb-lg-0">
                                    <label
                                        htmlFor=""
                                        className="pe-2 d-flex align-items-center fs-14 text-lite"
                                    >
                                        Phone Number
                                    </label>
                                    <input type="text"
                                        className="form-control input-sm"
                                        value={customerDetailsObj?.CustomerContact}
                                    />
                                </div>
                                <div className="flex-nowrap mb-lg-0">
                                    <label
                                        htmlFor=""
                                        className="pe-2 d-flex align-items-center fs-14 text-lite"
                                    >
                                        Fax Number:
                                    </label>
                                    <input type="text"
                                        className="form-control input-sm"
                                        value={customerDetailsObj?.CustomerContact}
                                    />
                                </div>
                            </div>
                            <div></div>
                        </div>

                        <div className="card-body p-4 border-bottom">

                            <div className="card-table table-responsive">
                                <table className="table table-form disable-field">

                                    <thead>
                                        <tr>
                                            <td scope="col" className="width-lg-1"></td>
                                            <td scope="col" className="width-lg-4">
                                                Qty
                                            </td>
                                            <td scope="col" className="width-lg-4">
                                                Unit
                                            </td>
                                            <td scope="col" className="width-lg-6">
                                                Produce
                                            </td>
                                            <td scope="col" className="width-lg-6">
                                                Agent
                                            </td>
                                            <td scope="col" className="width-lg-6">
                                                Comment
                                            </td>
                                            <td scope="col" className="width-lg-6">
                                                Produce Credit
                                            </td>
                                            <td scope="col" className="width-lg-1"></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {creditDetails.length > 0 && creditDetails.map((creditDetailItem, index) => {
                                            return (<tr key={index + 1} className="custom-space">
                                                <td valign="middle">
                                                    <img src={triangle} className="indicator" alt="" />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        className={`form-control input-sm text-end input-width-90 ${errors[`Qty` + index] ? "is-invalid" : ''}`}
                                                        placeholder="Qty"
                                                        onChange={(e) => {
                                                            setCreditDetails(prevProdDetails => {
                                                                const updatedProdDetails = [...prevProdDetails];
                                                                updatedProdDetails[index].Qty = e.target.value;
                                                                return updatedProdDetails;
                                                            });
                                                        }}
                                                        ref={el => creditInputRefs.current[index] = el}
                                                        value={creditDetailItem.Qty}
                                                        onBlur={(e) => checkError(e.target.value, index, 'Qty')}
                                                    />
                                                </td>
                                                <td>
                                                    <Select
                                                        className={`input-sm input-width-90 ${errors[`UnitID` + index] ? "react-select-invalid" : ''}`}
                                                        value={units.find(unit => unit.value == creditDetailItem.UnitID) || ''}
                                                        options={units}
                                                        placeholder="Select Unit"
                                                        onChange={(e) => {
                                                            setCreditDetails(prevProdDetails => {
                                                                const updatedProdDetails = [...prevProdDetails];
                                                                updatedProdDetails[index].UnitID = e.value;
                                                                return updatedProdDetails;
                                                            });
                                                        }}
                                                        components={{ Option: CustomOption }}
                                                        onBlur={(e) => checkError(creditDetailItem.UnitID || '', index, 'UnitID')}
                                                    ></Select>
                                                </td>
                                                <td>
                                                    <Select
                                                        className={`input-sm input-width-90 ${errors[`ProductID` + index] ? "react-select-invalid" : ''}`}
                                                        value={products.find(product => product.value == creditDetailItem.ProductID) || ''}
                                                        options={products}
                                                        placeholder="Select Product"
                                                        onChange={(e) => {
                                                            setCreditDetails(prevProdDetails => {
                                                                const updatedProdDetails = [...prevProdDetails];
                                                                updatedProdDetails[index].ProductID = e.value;
                                                                return updatedProdDetails;
                                                            });
                                                        }}
                                                        components={{ Option: CustomOption }}
                                                        onBlur={(e) => checkError(creditDetailItem.ProductID || '', index, 'ProductID')}
                                                    ></Select>
                                                </td>
                                                <td>
                                                    <Select
                                                        className={`input-sm input-width-90 ${errors[`AgentID` + index] ? "react-select-invalid" : ''}`}
                                                        value={agents.find(agent => agent.value == creditDetailItem.AgentID) || ''}
                                                        options={agents}
                                                        placeholder="Select Agent"
                                                        onChange={(e) => {
                                                            setCreditDetails(prevProdDetails => {
                                                                const updatedProdDetails = [...prevProdDetails];
                                                                updatedProdDetails[index].AgentID = e.value;
                                                                return updatedProdDetails;
                                                            });
                                                        }}
                                                        components={{ Option: CustomOption }}
                                                        onBlur={(e) => checkError(creditDetailItem.AgentID || '', index, 'AgentID')}
                                                    ></Select>
                                                </td>
                                                <td>
                                                    <div>
                                                        <input
                                                            type="text"
                                                            className="form-control input-sm text-end ps-4 input-width-110"
                                                            value={creditDetailItem.Comment}
                                                            onChange={(e) => {
                                                                setCreditDetails(prevProdDetails => {
                                                                    const updatedProdDetails = [...prevProdDetails];
                                                                    updatedProdDetails[index].Comment = e.target.value;
                                                                    return updatedProdDetails;
                                                                });
                                                            }}

                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="position-relative input-icon">
                                                        <input
                                                            type="text"
                                                            className={`form-control input-sm text-end ps-4 input-width-110 ${errors[`ProdCreditAmt` + index] ? "is-invalid" : ''}`}
                                                            value={creditDetailItem.ProdCreditAmt}
                                                            onChange={(e) => {
                                                                setCreditDetails(prevProdDetails => {
                                                                    const updatedProdDetails = [...prevProdDetails];
                                                                    updatedProdDetails[index].ProdCreditAmt = formatPrice(e.target.value);
                                                                    return updatedProdDetails;
                                                                });
                                                            }}
                                                            ref={el => creditEndInputRefs.current[index] = el}
                                                            onBlur={(e) => {
                                                                setCreditDetails(prevProdDetails => {
                                                                    const updatedProdDetails = [...prevProdDetails];
                                                                    updatedProdDetails[index].ProdCreditAmt = addTrailingZeros(e.target.value);
                                                                    return updatedProdDetails;
                                                                });
                                                                addNewRow(index);
                                                                calculateGST(addTrailingZeros(e.target.value), index);
                                                                checkError(parseInt(e.target.value), index, 'ProdCreditAmt');
                                                            }}
                                                        />
                                                        <span className="text-lite cps-10 fs-14">$</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-inline-flex align-items-center justify-content-end flex-grow-1">
                                                        <div
                                                            style={{
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => handleDelete(index)}
                                                            className={`text-decoration-none ${creditDetails.length - 1 === index ? 'd-none' : ''} `}
                                                        >
                                                            <i className="icon icon-delete ms-3 text-danger fw-bold"></i>
                                                        </div>
                                                    </div>
                                                </td>

                                            </tr>)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            {!message && <div className="text-center"><span className='text-danger'>Kindly Save the Data before Exit Otherwise Data will be lost</span></div>}
                            <div className="row d-flex justify-content-between align-items-end mt-2 mt-lg-0 pb-3">
                                <div className="col-md-2 d-flex">
                                    <label className="p-1">
                                        Items:
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control input-sm text-end ps-4"
                                        value={creditDetails.length - 1}
                                        readOnly
                                    />
                                </div>
                                <div className="col-md-2 d-flex">
                                    <label className="p-1">
                                        Total:
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control input-sm text-end ps-4"
                                        value={calculateTotalCredit()}
                                        readOnly
                                    />
                                </div>
                            </div>

                            <div className="col d-flex flex-column justify-content-between align-items-end mt-4 mt-lg-0">

                                <div className="d-flex">
                                    <button type="button"
                                        onClick={handlePreview}
                                        disabled={creditDetails.length === 1}
                                        className="btn btn-md btn-outline-secondary d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                                    >
                                        Preview
                                    </button>
                                    <button type="button"
                                        onClick={handleSave}
                                        disabled={creditDetails.length === 1}
                                        className="btn btn-md btn-outline-secondary d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                                    >
                                        Save
                                    </button>
                                    <button type="button"
                                        onClick={() => { navigate("/veg-art") }}
                                        className="btn btn-md btn-secondary text-white d-flex align-items-center px-4 fw-medium rounded-3"
                                    >
                                        Exit
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </main>
        </React.Fragment >
    )
}

export default ProduceCredit
